// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }

var wasmImportedFuncCache0;
var wasmImportedFuncCache1;
var wasmImportedFuncCache2;
var wasmImportedFuncCache3;
var wasmImportedFuncCache4;
var wasmImportedFuncCache5;
var wasmImportedFuncCache6;
var wasmImportedFuncCache7;
var wasmImportedFuncCache8;
var wasmImportedFuncCache9;
var wasmImportedFuncCache10;
var wasmImportedFuncCache11;
var wasmImportedFuncCache12;
var wasmImportedFuncCache13;
var wasmImportedFuncCache14;
var wasmImportedFuncCache15;
var wasmImportedFuncCache16;
var wasmImportedFuncCache17;
var wasmImportedFuncCache18;
var wasmImportedFuncCache19;
var wasmImportedFuncCache20;
var wasmImportedFuncCache21;
var wasmImportedFuncCache22;
var wasmImportedFuncCache23;
var wasmImportedFuncCache24;
var wasmImportedFuncCache25;
var wasmImportedFuncCache26;
var wasmImportedFuncCache27;
var wasmImportedFuncCache28;
var wasmImportedFuncCache29;
var wasmImportedFuncCache30;
var wasmImportedFuncCache31;
var wasmImportedFuncCache32;
var wasmImportedFuncCache33;
var wasmImportedFuncCache34;
var wasmImportObjects = {
	1984: function() {
		return {
			"./photon_rs_bg.js": {
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache0 === undefined) wasmImportedFuncCache0 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache0["ug$"](p0i32);
				},
				"__wbg_new_693216e109162396": function() {
					if(wasmImportedFuncCache1 === undefined) wasmImportedFuncCache1 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache1["Ih1"]();
				},
				"__wbg_stack_0ddaca5d1abfb52f": function(p0i32,p1i32) {
					if(wasmImportedFuncCache2 === undefined) wasmImportedFuncCache2 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache2["yq"](p0i32,p1i32);
				},
				"__wbg_error_09919627ac0992f5": function(p0i32,p1i32) {
					if(wasmImportedFuncCache3 === undefined) wasmImportedFuncCache3 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache3["gkX"](p0i32,p1i32);
				},
				"__wbg_instanceof_Window_c4b70662a0d2c5ec": function(p0i32) {
					if(wasmImportedFuncCache4 === undefined) wasmImportedFuncCache4 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache4["UmC"](p0i32);
				},
				"__wbg_document_1c64944725c0d81d": function(p0i32) {
					if(wasmImportedFuncCache5 === undefined) wasmImportedFuncCache5 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache5["WSM"](p0i32);
				},
				"__wbg_body_78ae4fd43b446013": function(p0i32) {
					if(wasmImportedFuncCache6 === undefined) wasmImportedFuncCache6 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache6["V7l"](p0i32);
				},
				"__wbg_createElement_86c152812a141a62": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache7 === undefined) wasmImportedFuncCache7 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache7["aIM"](p0i32,p1i32,p2i32);
				},
				"__wbg_width_16bd64d09cbf5661": function(p0i32) {
					if(wasmImportedFuncCache8 === undefined) wasmImportedFuncCache8 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache8["r1Y"](p0i32);
				},
				"__wbg_height_368bb86c37d51bc9": function(p0i32) {
					if(wasmImportedFuncCache9 === undefined) wasmImportedFuncCache9 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache9["SdR"](p0i32);
				},
				"__wbg_data_1ae7496c58caf755": function(p0i32,p1i32) {
					if(wasmImportedFuncCache10 === undefined) wasmImportedFuncCache10 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache10["cKY"](p0i32,p1i32);
				},
				"__wbg_newwithu8clampedarrayandsh_1b8c6e1bede43657": function(p0i32,p1i32,p2i32,p3i32) {
					if(wasmImportedFuncCache11 === undefined) wasmImportedFuncCache11 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache11["fo0"](p0i32,p1i32,p2i32,p3i32);
				},
				"__wbg_instanceof_CanvasRenderingContext2d_3abbe7ec7af32cae": function(p0i32) {
					if(wasmImportedFuncCache12 === undefined) wasmImportedFuncCache12 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache12["lUt"](p0i32);
				},
				"__wbg_drawImage_9e2d13329d92a0a3": function(p0i32,p1i32,p2f64,p3f64,p4f64,p5f64,p6f64,p7f64,p8f64,p9f64) {
					if(wasmImportedFuncCache13 === undefined) wasmImportedFuncCache13 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache13["ZTp"](p0i32,p1i32,p2f64,p3f64,p4f64,p5f64,p6f64,p7f64,p8f64,p9f64);
				},
				"__wbg_getImageData_9ffc3df78ca3dbc9": function(p0i32,p1f64,p2f64,p3f64,p4f64) {
					if(wasmImportedFuncCache14 === undefined) wasmImportedFuncCache14 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache14["Tf2"](p0i32,p1f64,p2f64,p3f64,p4f64);
				},
				"__wbg_putImageData_b9544b271e569392": function(p0i32,p1i32,p2f64,p3f64) {
					if(wasmImportedFuncCache15 === undefined) wasmImportedFuncCache15 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache15["QsE"](p0i32,p1i32,p2f64,p3f64);
				},
				"__wbg_settextContent_799ebbf96e16265d": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache16 === undefined) wasmImportedFuncCache16 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache16["OvF"](p0i32,p1i32,p2i32);
				},
				"__wbg_appendChild_d318db34c4559916": function(p0i32,p1i32) {
					if(wasmImportedFuncCache17 === undefined) wasmImportedFuncCache17 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache17["z8C"](p0i32,p1i32);
				},
				"__wbg_instanceof_HtmlCanvasElement_25d964a0dde6717e": function(p0i32) {
					if(wasmImportedFuncCache18 === undefined) wasmImportedFuncCache18 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache18["Ve6"](p0i32);
				},
				"__wbg_width_555f63ab09ba7d3f": function(p0i32) {
					if(wasmImportedFuncCache19 === undefined) wasmImportedFuncCache19 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache19["$jk"](p0i32);
				},
				"__wbg_setwidth_c1a7061891b71f25": function(p0i32,p1i32) {
					if(wasmImportedFuncCache20 === undefined) wasmImportedFuncCache20 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache20["J2u"](p0i32,p1i32);
				},
				"__wbg_height_7153faec70fbaf7b": function(p0i32) {
					if(wasmImportedFuncCache21 === undefined) wasmImportedFuncCache21 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache21["xxn"](p0i32);
				},
				"__wbg_setheight_88894b05710ff752": function(p0i32,p1i32) {
					if(wasmImportedFuncCache22 === undefined) wasmImportedFuncCache22 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache22["UQl"](p0i32,p1i32);
				},
				"__wbg_getContext_f701d0231ae22393": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache23 === undefined) wasmImportedFuncCache23 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache23["NVK"](p0i32,p1i32,p2i32);
				},
				"__wbg_newnoargs_be86524d73f67598": function(p0i32,p1i32) {
					if(wasmImportedFuncCache24 === undefined) wasmImportedFuncCache24 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache24["wgn"](p0i32,p1i32);
				},
				"__wbg_call_888d259a5fefc347": function(p0i32,p1i32) {
					if(wasmImportedFuncCache25 === undefined) wasmImportedFuncCache25 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache25["BTj"](p0i32,p1i32);
				},
				"__wbindgen_object_clone_ref": function(p0i32) {
					if(wasmImportedFuncCache26 === undefined) wasmImportedFuncCache26 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache26["m_1"](p0i32);
				},
				"__wbg_self_c6fbdfc2918d5e58": function() {
					if(wasmImportedFuncCache27 === undefined) wasmImportedFuncCache27 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache27["JXq"]();
				},
				"__wbg_window_baec038b5ab35c54": function() {
					if(wasmImportedFuncCache28 === undefined) wasmImportedFuncCache28 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache28["xdS"]();
				},
				"__wbg_globalThis_3f735a5746d41fbd": function() {
					if(wasmImportedFuncCache29 === undefined) wasmImportedFuncCache29 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache29["udq"]();
				},
				"__wbg_global_1bc0b39582740e95": function() {
					if(wasmImportedFuncCache30 === undefined) wasmImportedFuncCache30 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache30["PTw"]();
				},
				"__wbindgen_is_undefined": function(p0i32) {
					if(wasmImportedFuncCache31 === undefined) wasmImportedFuncCache31 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache31["XP4"](p0i32);
				},
				"__wbindgen_debug_string": function(p0i32,p1i32) {
					if(wasmImportedFuncCache32 === undefined) wasmImportedFuncCache32 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache32["fYP"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache33 === undefined) wasmImportedFuncCache33 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache33["Or8"](p0i32,p1i32);
				},
				"__wbindgen_rethrow": function(p0i32) {
					if(wasmImportedFuncCache34 === undefined) wasmImportedFuncCache34 = __webpack_require__.c[1401].exports;
					return wasmImportedFuncCache34["nDt"](p0i32);
				}
			}
		};
	},
};

var wasmModuleMap = {
	"756": [
		1984
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"756":{"1984":"0e01a24452ab4ca9805c"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};